import https from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
const BASE_URL_V2 = 'users/v2/app';
const getHubUsersKey = () => 'HubUsers';
const _fetchHubUsers = () => https.get(`${BASE_URL_V2}/hub-users`);
const getHubUsersForms = () => getFromEarlyRequest(getHubUsersKey(), () => _fetchHubUsers());
export default getHubUsersForms;